export var TripPrivacyType;
(function (TripPrivacyType) {
    TripPrivacyType["COMPANY_ONLY"] = "COMPANY_ONLY";
    TripPrivacyType["PUBLIC"] = "public";
    TripPrivacyType["INVITE_ONLY"] = "invite-only";
})(TripPrivacyType || (TripPrivacyType = {}));
